import styled from "@emotion/styled";

import { isTernaryOperator } from "../../../effects-conditions";
import { ValueConfigSummaryText } from "../../../values/forms/ValueConfigSummaryText.tsx";
import type { randomConditionBuilder } from "./randomConditionBuilder";

const Container = styled.div``;

const Title = styled.span``;

const Value = styled.span`
  color: ${({ theme }) => theme.secondary};
  font-weight: bold;
`;

export const RandomConditionSummary: typeof randomConditionBuilder.views.summary = ({
  spec: { title },
  config: { operator, value, value2 },
}) => {
  const first = value === undefined ? "" : <ValueConfigSummaryText value={value} />;
  const second = value2 === undefined ? "" : <ValueConfigSummaryText value={value2} />;

  const v = isTernaryOperator(operator) ? (
    <>
      {first} and {second}
    </>
  ) : (
    first
  );

  return (
    <Container>
      {!!title && <Title>{title}</Title>} {operator} {value !== undefined && <Value>{v}</Value>}
    </Container>
  );
};
